// 神策埋点sdk
import favUtil, { appName } from './fav-util'
import sensors from 'sa-sdk-javascript'

const env = favUtil.env()
window.sensors = window.$sensors = sensors
// Vue.prototype.$track = sensors.track

// 获取用户信息
function getUserInfo() {
  return new Promise((resolve, reject) => {
    window.qing.call('getPersonInfo', {
      success: function (res) {
        if (res && res.success && res.data) {
          resolve(res.data)
        } else {
          resolve()
        }
      },
      error: function (error) {
        reject(error)
      }
    })
  })
}

// 需要登录的操作
function loginInit() {
  return new Promise(async resolve => {
    init()
    let userInfo = await getUserInfo().catch(err => console.log(err))
    let { eid = '', companyName = '', name = '', jobNo = '', department = '', fullDepartment = '', jobTitle = '' } = userInfo || {}
    let commonProperty = {
      platform_type: 'H5',
      is_login: true,
      app_name: appName,
      language: favUtil.getLanguage(),
      eid,
      eid_name: companyName
    }
    // 注册公共属性
    sensors.registerPage(commonProperty)
    // Web 页面浏览
    sensors.quick('autoTrack', commonProperty)
    // 全域用户关联
    sensors.loginWithKey('$identity_login_id', jobNo)
    // 设置用户属性
    let _departments = []
    if (fullDepartment) {
      // 主要是!分隔符，兼容一下/分隔符
      if (fullDepartment.indexOf('!') !== -1) {
        _departments = fullDepartment.split('!')
      } else {
        _departments = fullDepartment.split('/')
      }
    }
    sensors.setProfile({
      nick_name: name,
      job_No: jobNo,
      department: department || '',
      department_top: _departments[0] || '',
      department_second: _departments[1] || '',
      department_third: _departments[2] || '',
      position: jobTitle || ''
    })
    resolve()
  })
}

function init() {
  // 初始化
  sensors.init({
    server_url: getServerUrl(),
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      collect_tags: {
        div: {
          max_level: 3 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        li: true,
        img: true,
        svg: true,
        span: true
      },
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default'
    },
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    show_log: env !== 'release' // 生产环境关闭控制台日志打印
  })
  // 页面浏览时长
  sensors.use('PageLeave')
  // 页面加载时长
  sensors.use('PageLoad')
}

// 上报地址
function getServerUrl() {
  if (env === 'release') {
    return 'https://dmg-dts-api.myoas.com/sa?project=TSP_MTP'
  }
  return 'https://dmg-dts-api-test.myoas.com/sa?project=TSP_MTP'
}

export default function () {
  if (env !== 'test' && env !== 'release') {
    return
  }
  if(typeof requestIdleCallback === 'function'){
    requestIdleCallback(() => {
      loginInit().catch(err => { console.error('initSensors', err) })
    })
  }
  else{
    loginInit().catch(err => { console.error('initSensors', err) })
  }

}
